import { render, staticRenderFns } from "./addBusi.vue?vue&type=template&id=5e1be6ea&scoped=true&"
import script from "./addBusi.vue?vue&type=script&lang=js&"
export * from "./addBusi.vue?vue&type=script&lang=js&"
import style0 from "./addBusi.vue?vue&type=style&index=0&id=5e1be6ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1be6ea",
  null
  
)

export default component.exports